import { useEffect, useState } from "react";
import axios from "axios";
import Adminnavbar from "../Adminnavbar";
import { NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";

export default function PdfDownloadList() {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  // 🔍 Search
  const [search, setSearch] = useState("");

  // 📄 Pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    fetchDownloadUsers();
  }, []);

  const fetchDownloadUsers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/download/all`
      );

      if (Array.isArray(res.data)) {
        setData(res.data);
      } else if (res.data?.data) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("API ERROR ❌", err);
      setData([]);
    } finally {
      setLoader(false);
    }
  };

  // 🔍 Search filter
  const filteredData = data.filter((item) =>
    `${item.title} ${item.name} ${item.email}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  // 📄 Pagination logic
  const offset = currentPage * itemsPerPage;
  const currentData = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  return (
    <>
      <Adminnavbar />

      <div className="page-wrapper page-settings">
        <div className="content">

          {/* 🔹 Breadcrumb */}
          <nav
            aria-label="breadcrumb"
            style={{ "--bs-breadcrumb-divider": "none" }}
          >
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/admindashbord">Dashboard</NavLink> /
              </li>
              <li className="breadcrumb-item active">PDF Download List</li>
            </ol>
          </nav>

          {/* 🔹 Header */}
          <div className="content-page-header content-page-headersplit d-flex justify-content-between align-items-center">
            <h5>PDF Download List</h5>
          </div>

          {/* 🔍 Search */}
          <div className="d-flex gap-2 my-4">
            <input
              className="form-control"
              type="text"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
              style={{ width: "550px" }}
            />
          </div>

          {/* 📋 Table */}
          <div className="table-responsive">
            <table className="table datatable">
              <thead>
                <tr>
                  <th>Index</th>
                  <th>PDF Title</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : currentData.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No data found
                    </td>
                  </tr>
                ) : (
                  currentData.map((item, index) => (
                    <tr key={index}>
                      <td>{offset + index + 1}</td>
                      <td>{item.title || "-"}</td>
                      <td>{item.name || "-"}</td>

                      {/* ✅ EMAIL FORMAT FIXED */}
                      <td style={{ textTransform: "lowercase" }}>
                        {item.email ? item.email.toLowerCase() : "-"}
                      </td>

                      <td>
                        {item.created_at
                          ? new Date(item.created_at).toLocaleDateString(
                              "en-IN"
                            )
                          : "-"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* 📄 Pagination */}
          {!loader && filteredData.length > 0 && (
            <nav className="mt-4 d-flex justify-content-end gap-2 align-items-center">
              <select
                className="form-select"
                style={{ width: "70px" }}
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>

              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                pageLinkClassName={"page-link"}
                previousLinkClassName={"page-link"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                disabledClassName={"disabled"}
              />
            </nav>
          )}
        </div>
      </div>
    </>
  );
}
